import React from "react";
import { Modal, Button, message } from 'antd';
import OneFeedback from "./oneFeedback.js";
import FormFeedback from "./formFeedback.js";
import { feedbackAPI } from "./API/feedbackAPI.js";
import styles from "./feedback.module.css";

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formVisible: false,
      sendDisabled: true,
    }

    this.hasErrors = this.hasErrors.bind(this);
  }

  hasErrors(disabled) {
    this.setState({ sendDisabled: disabled });
  }

  showModal = () => {
    this.setState({
      formVisible: true,
    });
  };

  handleCancel = e => {
    this.setState({
      formVisible: false,
    });

    this.form.props.form.resetFields();
  };

  handleOk = e => {
    this.setState({
      formVisible: false,
    });
    //const value = this.form.props.form.getFieldsValue();
    //this.form.props.form.resetFields();
      //sendFeedback(value, ()=>{
          //message.success("Отзыв отправлен");
      //})
  }

  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";

    let feedbacks = [];

    feedbackAPI.map((value, index) => {
      feedbacks.push(<OneFeedback feedback={value} />);
      return undefined;
    });

    const feedbackForm = <div className="formWrapper">
      <FormFeedback
        wrappedComponentRef={(form) => this.form = form}
        formHasErrors={this.hasErrors} />
    </div>;

    return (
      <div className={styles.container} style={{ marginBottom: firefox ? "5.5em" : "0em" }}>
        <div style={{
          marginLeft: "2vw",
          marginBottom: "1.7em",
          marginTop: "0.2em"
        }}>
          <Button className="roundButton" type="primary" onClick={this.showModal}>
            НАПИСАТЬ ОТЗЫВ
        </Button>
        </div>
        <div>
          <Modal
            title="Форма отзыва"
            visible={this.state.formVisible}
            onCancel={this.handleCancel}
            className="modalWrapper"
            width="58em"
            closable={true}
            footer={[
              <Button key="cancel" onClick={this.handleCancel}
                style={{ width: "7.5em" }}>
                Отмена
              </Button>,
              <Button
                disabled={this.state.sendDisabled}
                onClick={this.handleOk}
                type="primary" form="pagesFeedbackForm" key="submit" htmlType="submit"
                style={{ width: "12em" }}>
                Отправить отзыв
              </Button>,
            ]}
          >
            {feedbackForm}
          </Modal>

        </div>
        <div className={styles.feedbackCarouselWrapper}>
          {feedbacks}
        </div>
      </div >
    );
  }
}

export default Feedback;
